var path = 'event/event-row-stats.tpl.html';
var html = " <div class=tb-cell flex>{{event.createdTime | date : 'yyyy-MM-dd HH:mm:ss'}}</div> <div class=tb-cell flex>{{event.body.server}}</div> <div class=\"tb-cell tb-number\" flex>{{event.body.messagesProcessed}}</div> <div class=\"tb-cell tb-number\" flex>{{event.body.errorsOccurred}}</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-row-stats.tpl.html
// module id = 1509
// module chunks = 1